export const formatAuthorsForCitation=(authors,authorType,isFirst=true)=> {
// Separar los autores por tipo
const personalAuthors=authors.filter(author=> author.type==='personal' || !author.type);
const institutionalAuthors=authors.filter(author=> author.type==='institutional');

// Si hay ambos tipos de autores,combinarlos
let formattedAuthors='';

// Formatear autores personales
if (personalAuthors.length > 0) {
if (personalAuthors.length===1) {
formattedAuthors=formatLastNameForCitation(personalAuthors[0].lastNames);
} else if (personalAuthors.length===2) {
// Para citas narrativas usar "y",para parentéticas se usará "&" en la función de generación de citas
formattedAuthors=`${formatLastNameForCitation(personalAuthors[0].lastNames)} y ${formatLastNameForCitation(personalAuthors[1].lastNames)}`;
} else if (personalAuthors.length > 2) {
// Para 3 o más autores,usar "et al." siempre
formattedAuthors=`${formatLastNameForCitation(personalAuthors[0].lastNames)} et al.`;
}
}

// Formatear autores institucionales
if (institutionalAuthors.length > 0) {
const formattedInstitutional=institutionalAuthors.map((author,index)=> {
// Para citas narrativas,mostrar SOLO el nombre completo (la sigla va dentro del paréntesis con el año)
// Para citas subsecuentes,usar solo la abreviatura si existe
if (author.abbreviation && !isFirst) {
return author.abbreviation;
}
// Para primera cita narrativa,mostrar solo el nombre completo
return index===0 ? author.name : (index===institutionalAuthors.length - 1 ? ` y ${author.name}` : `,${author.name}`);
}).join('');

// Combinar con autores personales si existen
formattedAuthors=formattedAuthors ? `${formattedAuthors} y ${formattedInstitutional}` : formattedInstitutional;
}

return formattedAuthors;
};

export const formatAuthorsForParenthetical=(authors,authorType,isFirst=true)=> {
// Separar los autores por tipo
const personalAuthors=authors.filter(author=> author.type==='personal' || !author.type);
const institutionalAuthors=authors.filter(author=> author.type==='institutional');

// Si hay ambos tipos de autores,combinarlos
let formattedAuthors='';

// Formatear autores personales
if (personalAuthors.length > 0) {
if (personalAuthors.length===1) {
formattedAuthors=formatLastNameForCitation(personalAuthors[0].lastNames);
} else if (personalAuthors.length===2) {
// Para citas parentéticas usar "&"
formattedAuthors=`${formatLastNameForCitation(personalAuthors[0].lastNames)} & ${formatLastNameForCitation(personalAuthors[1].lastNames)}`;
} else if (personalAuthors.length > 2) {
// Para 3 o más autores,usar "et al." siempre
formattedAuthors=`${formatLastNameForCitation(personalAuthors[0].lastNames)} et al.`;
}
}

// Formatear autores institucionales
if (institutionalAuthors.length > 0) {
const formattedInstitutional=institutionalAuthors.map((author,index)=> {
// Para citas subsecuentes,usar solo la abreviatura si existe
if (author.abbreviation && !isFirst) {
return author.abbreviation;
}
// Para primera cita parentética,mostrar nombre completo y abreviatura entre corchetes si existe
const name=author.abbreviation && isFirst ? `${author.name} [${author.abbreviation}]` : author.name;
return index===0 ? name : (index===institutionalAuthors.length - 1 ? ` & ${name}` : `,${name}`);
}).join('');

// Combinar con autores personales si existen
formattedAuthors=formattedAuthors ? `${formattedAuthors} & ${formattedInstitutional}` : formattedInstitutional;
}

return formattedAuthors;
};

export const formatAuthorsForReference=(authors,authorType)=> {
if (!authors || authors.length===0) {
return '';
}

const formattedAuthorStrings=authors.map(author=> {
if (author.type==='institutional') {
if (author.abbreviation) {
return `${author.name} [${author.abbreviation}]`;
}
return author.name;
} else { // personal
const initials=author.firstNames
.split(/\s+/)
.map(name=> `${name.charAt(0).toUpperCase()}.`)
.join(' ');
const formattedLastName=formatLastNameForReference(author.lastNames);
return `${formattedLastName}, ${initials}`;
}
});

let result='';
if (formattedAuthorStrings.length===1) {
result=formattedAuthorStrings[0];
} else {
const lastAuthor=formattedAuthorStrings.pop();
result=`${formattedAuthorStrings.join(', ')}, & ${lastAuthor}`;
}

const lastAuthorInList=authors[authors.length - 1];
if (lastAuthorInList.type==='institutional') {
result +='.';
}

return result;
};

// Función auxiliar para formatear apellidos en citas (mantiene minúsculas en partículas)
const formatLastNameForCitation=(lastName)=> {
if (!lastName) return '';

const particles=['de la','de los','del','van','van der','von','von der'];
for (const particle of particles) {
if (lastName.toLowerCase().startsWith(particle + ' ')) {
const restOfName=lastName.substring(particle.length + 1);
return `${particle} ${restOfName}`;
}
}

return lastName;
};

// Función auxiliar para formatear apellidos en referencias (mantiene minúsculas en partículas)
const formatLastNameForReference=(lastName)=> {
if (!lastName) return '';

const particles=['de la','de los','del','van','van der','von','von der'];
for (const particle of particles) {
if (lastName.toLowerCase().startsWith(particle + ' ')) {
const restOfName=lastName.substring(particle.length + 1);
return `${particle} ${restOfName}`;
}
}

return lastName;
};

export const formatEditorsForReference=(editors,editorType,role)=> {
if (!editors || editors.length===0) {
return '';
}

let formattedEditorStrings=[];
if (editorType==='institutional') {
formattedEditorStrings=editors.map(editor=> {
if (editor.abbreviation) {
return `${editor.name} [${editor.abbreviation}]`;
}
return editor.name;
});
} else { // personal
formattedEditorStrings=editors.map(editor=> {
const initials=editor.firstNames
.split(/\s+/)
.map(name=> `${name.charAt(0).toUpperCase()}.`)
.join(' ');
return `${initials} ${editor.lastNames}`;
});
}

let editorsText='';
if (formattedEditorStrings.length===1) {
editorsText=formattedEditorStrings[0];
} else {
const lastEditor=formattedEditorStrings.pop();
editorsText=`${formattedEditorStrings.join(', ')}, & ${lastEditor}`;
}

const roleText=editors.length > 1 ?
(role==='editor' ? 'Eds.' : role==='compilador' ? 'Comps.' : 'Coords.') :
(role==='editor' ? 'Ed.' : role==='compilador' ? 'Comp.' : 'Coord.');

return `${editorsText} (${roleText})`;
};

export const formatEditionForReference=(edition)=> {
if (!edition || edition==='1') return '';

// Convertir a número si es un string
const editionNum=typeof edition==='string' ? parseInt(edition,10) : edition;

// Si es un número válido,formatearlo
if (!isNaN(editionNum)) {
return `(${editionNum}.ª ed.)`;
}

// Si ya viene con formato,devolverlo tal cual
return `(${edition})`;
};

export const formatURL=(url)=> {
if (!url) return '';

let formattedUrl = '';

// Si ya es una URL completa con https:// o http://
if (url.startsWith('http://') || url.startsWith('https://')) {
formattedUrl = url;
} else {
// Si no tiene prefijo,añadir https://
formattedUrl = `https://${url}`;
}

// Función para insertar saltos de línea inteligentes en URLs largas sin cortar palabras
const insertSmartLineBreaks = (urlText) => {
// Si la URL es corta (menos de 70 caracteres), no hacer nada
if (urlText.length <= 70) {
return urlText;
}

// Dividir la URL en partes para analizar cada segmento
const urlParts = urlText.split('/');
let result = '';
let currentLine = '';
const maxLineLength = 70;

for (let i = 0; i < urlParts.length; i++) {
const part = urlParts[i];
const separator = i === urlParts.length - 1 ? '' : '/';
const fullPart = part + separator;

// Si añadir esta parte excede la longitud máxima de línea
if (currentLine.length + fullPart.length > maxLineLength && currentLine.length > 0) {
// Verificar si la parte actual contiene parámetros de consulta
if (part.includes('?') || part.includes('&') || part.includes('=')) {
// Manejar parámetros de consulta de forma especial
const queryParts = part.split(/([?&=])/);
let tempLine = currentLine;

for (let j = 0; j < queryParts.length; j++) {
const queryPart = queryParts[j];

if (tempLine.length + queryPart.length > maxLineLength && tempLine !== currentLine) {
result += tempLine + '<br/>';
tempLine = queryPart;
} else {
tempLine += queryPart;
}
}
currentLine = tempLine + separator;
} else {
// Para segmentos normales de la URL, hacer salto de línea antes del segmento completo
result += currentLine + '<br/>';
currentLine = fullPart;
}
} else {
// Si cabe en la línea actual, añadirlo
currentLine += fullPart;
}
}

// Añadir la última línea
if (currentLine) {
result += currentLine;
}

// Si el resultado está vacío, devolver la URL original
return result || urlText;
};

const urlWithBreaks = insertSmartLineBreaks(formattedUrl);

return `<a href="${formattedUrl}" target="_blank">${urlWithBreaks}</a>`;
};

export const formatDOI=(doi)=> {
if (!doi) return '';

// Eliminar cualquier prefijo doi.org duplicado
let cleanDoi=doi;

// Si comienza con http://doi.org/ o https://doi.org/
if (doi.match(/^https?:\/\/doi\.org\//i)) {
cleanDoi=doi.replace(/^https?:\/\/doi\.org\//i,'');
}
// Si comienza con doi.org/ (sin http/https)
else if (doi.toLowerCase().startsWith('doi.org/')) {
cleanDoi=doi.substring(8);
}
// Si comienza con "doi:"
else if (doi.toLowerCase().startsWith('doi:')) {
cleanDoi=doi.substring(4).trim();
}

// Si después de limpiar,todavía comienza con doi.org/,eliminarlo nuevamente
if (cleanDoi.toLowerCase().startsWith('doi.org/')) {
cleanDoi=cleanDoi.substring(8);
}

// Asegurarnos de que el DOI esté limpio de espacios iniciales o finales
cleanDoi=cleanDoi.trim();

// Función para insertar saltos de línea inteligentes en DOIs largos sin cortar palabras
const insertSmartLineBreaks = (doiText) => {
const fullDoi = `https://doi.org/${doiText}`;

// Si el DOI es corto (menos de 70 caracteres), no hacer nada
if (fullDoi.length <= 70) {
return fullDoi;
}

// Dividir el DOI en segmentos lógicos para evitar cortar palabras
const doiParts = doiText.split('/');
let result = 'https://doi.org/';
let currentLine = result;
const maxLineLength = 70;

for (let i = 0; i < doiParts.length; i++) {
const part = doiParts[i];
const separator = i === doiParts.length - 1 ? '' : '/';
const fullPart = part + separator;

// Si añadir esta parte excede la longitud máxima de línea
if (currentLine.length + fullPart.length > maxLineLength && i > 0) {
// Hacer salto de línea antes del segmento completo
result = currentLine + '<br/>';
currentLine = fullPart;
} else {
// Si cabe en la línea actual o es la primera parte, añadirlo
if (i === 0) {
currentLine += fullPart;
} else {
currentLine += fullPart;
}
}
}

// Construir el resultado final
if (result.includes('<br/>')) {
return result + currentLine;
} else {
return currentLine;
}
};

const doiWithBreaks = insertSmartLineBreaks(cleanDoi);

// Formar el enlace completo
return `<a href="https://doi.org/${cleanDoi}" target="_blank">${doiWithBreaks}</a>`;
};

export const createCitationAndReference=(formData,citationFormatter,referenceFormatter)=> {
const citation=citationFormatter(formData);
const reference=referenceFormatter(formData);

return {citation,reference};
};